import { DarkMode, DarkModePreference } from '@afterpaytouch/core'
import { parseCookies, setCookie } from 'nookies'

/**
 * Gets the initial dark mode setting from the DOM attribute or defaults to System
 */
export const getInitialDarkMode = (): DarkMode => {
  if (typeof window === 'undefined') {
    return DarkMode.System
  }

  const darkModeAttr = document.documentElement.getAttribute('data-dark-mode')
  if (darkModeAttr === 'true') return DarkMode.Dark
  if (darkModeAttr === 'false') return DarkMode.Light
  return DarkMode.System
}

/**
 * Gets the user's dark mode preference from cookies
 */
export const getDarkModePreference = (): DarkModePreference | undefined => {
  if (typeof window === 'undefined') return undefined
  const cookies = parseCookies()
  const cookieValue = cookies['apt-dark-mode'] as DarkModePreference
  if (['dark', 'light', 'system'].includes(cookieValue)) {
    return cookieValue
  }
  return 'system'
}

/**
 * Sets the user's dark mode preference in cookies
 */
export const setDarkModePreference = (preference: DarkModePreference): void => {
  if (typeof window === 'undefined') return
  setCookie(null, 'apt-dark-mode', preference, {
    path: '/',
    sameSite: 'none',
    secure: true,
    maxAge: 365 * 24 * 60 * 60, // 1 year
  })
}
